import {
  SnackbarProvider,
  useSnackbar,
  SnackbarProviderProps,
} from 'notistack';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useRef } from 'react';

export const ConvergeSnackBarProvider = (props: SnackbarProviderProps) => {
  const notistackRef = useRef<SnackbarProvider>(null);

  return (
    <SnackbarProvider
      ref={notistackRef}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transitionDuration={50}
      autoHideDuration={5 * 1000}
      disableWindowBlurListener
      action={(key) => (
        <IconButton
          aria-label="close"
          color="inherit"
          onClick={() => {
            notistackRef.current?.closeSnackbar(key);
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
      {...props}
    />
  );
};

export const useConvergeSnackBar = () => {
  const { closeSnackbar, enqueueSnackbar: notify } = useSnackbar();
  return {
    closeSnackbar,
    notify,
  };
};
